import { IModel, IModelResponse } from '../../deprecated-api-models/types/model';

import { IJsonQuery } from '../../common/json_query';
import { ISearchOffersDesktopResponseDataSchema } from './search-offers-desktop.data';

export type TSearchOffersDesktopModel = IModel<TSearchOffersDesktopRequestSchema, TSearchOffersDesktopResponseSchema>;

const defaultConfig: TSearchOffersDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'searchOffers',
  pathApi: '/v2/search-offers-desktop/',
};

export function createSearchOffersDesktopModel(config: Partial<TSearchOffersDesktopModel>): TSearchOffersDesktopModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface ISearchOffersDesktopResponse200 extends IModelResponse<ISearchOffersDesktopResponseSchema> {
  statusCode: 200;
}

export interface ISearchOffersDesktopResponse400 extends IModelResponse<ISearchOffersDesktopErrorResponseSchema> {
  statusCode: 400;
}

export type TSearchOffersDesktopResponseSchema = ISearchOffersDesktopResponse200 | ISearchOffersDesktopResponse400;

export interface ISearchOffersDesktopPathRequestSchema {
  _subdomain: string;
  _path: string;
}

export interface ISearchOffersDesktopJsonQueryRequestSchema {
  jsonQuery: IJsonQuery;
}

export type TSearchOffersDesktopRequestSchema =
  | ISearchOffersDesktopPathRequestSchema
  | ISearchOffersDesktopJsonQueryRequestSchema;

export interface ISearchOffersDesktopResponseSchema {
  status: 'ok' | 'validationError';
  data: ISearchOffersDesktopResponseDataSchema | ISearchOffersDesktopRedirectResponseSchema;
}

export interface ISearchOffersDesktopErrorResponseSchema {
  errors: object[];
  message: string;
}

export interface ISearchOffersDesktopRedirectResponseSchema {
  redirectData: {
    location: string;
    statusCode?: number;
  };
}
